import { DateTime } from "luxon";

// TODO: nullability is wrong
export class GeoRehandleDTO {
  geoRehandleId: number;
  operationId: number;
  officerId?: number;
  loads?: number;
  movementFromId?: number;
  movementToId?: number;
  bucketTypeId?: number;
  spotterId?: number;
  plantId?: number;
  hour?: number;
  materialTypeClassId?: number;
  tonnes?: number;
  density?: number;
  wetTonnes?: number;
  adjTonnesHauled?: number;
  lastEdited?: DateTime;
  rowVersion?: string;

  constructor(data: {
    geoRehandleId: number;
    operationId: number;
    officerId?: number;
    loads?: number;
    movementFromId?: number;
    movementToId?: number;
    bucketTypeId?: number;
    spotterId?: number;
    plantId?: number;
    hour?: number;
    materialTypeClassId?: number;
    tonnes?: number;
    density?: number;
    wetTonnes?: number;
    adjTonnesHauled?: number;
    lastEdited?: DateTime;
    rowVersion?: string;
  }) {
    this.geoRehandleId = data.geoRehandleId;
    this.operationId = data.operationId;
    this.officerId = data.officerId;
    this.loads = data.loads;
    this.movementFromId = data.movementFromId;
    this.movementToId = data.movementToId;
    this.bucketTypeId = data.bucketTypeId;
    this.spotterId = data.spotterId;
    this.plantId = data.plantId;
    this.hour = data.hour;
    this.materialTypeClassId = data.materialTypeClassId;
    this.tonnes = data.tonnes;
    this.density = data.density;
    this.wetTonnes = data.wetTonnes;
    this.adjTonnesHauled = data.adjTonnesHauled;
    this.lastEdited = data.lastEdited;
    this.rowVersion = data.rowVersion;
  }
}